import profilesExportActionTypes from "../actions/profilesExportActionTypes";
import { reducerFactory } from "../../common/redux/reducers/reducerFactory";

export const profilesExportReducer = reducerFactory.readReducer(
  profilesExportActionTypes
);
